/**
 * Supabase-Client. Fehlen die Umgebungsvariablen, bleibt der Client null und das Spiel läuft
 * komplett offline (lokale Speicherstände, keine Highscores).
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase: SupabaseClient | null = url && key ? createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true } }) : null;
export const online = () => supabase !== null;
